const TunisiaSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4152_112590)">
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="#D80027"
      />
      <path
        d="M19.9998 29.565C25.2825 29.565 29.565 25.2825 29.565 19.9998C29.565 14.7171 25.2825 10.4346 19.9998 10.4346C14.7171 10.4346 10.4346 14.7171 10.4346 19.9998C10.4346 25.2825 14.7171 29.565 19.9998 29.565Z"
        fill="#F0F0F0"
      />
      <path
        d="M21.1779 16.3428L22.8189 18.6041L25.4764 17.7424L23.8329 20.0018L25.4737 22.263L22.817 21.398L21.1735 23.6574L21.1752 20.8636L18.5186 19.9986L21.1762 19.1368L21.1779 16.3428Z"
        fill="#D80027"
      />
      <path
        d="M22.1738 25.6517C19.0523 25.6517 16.5217 23.1211 16.5217 19.9995C16.5217 16.878 19.0523 14.3473 22.1738 14.3473C23.1471 14.3473 24.063 14.5934 24.8625 15.0267C23.6082 13.8001 21.893 13.043 19.9999 13.043C16.1581 13.043 13.0435 16.1575 13.0435 19.9995C13.0435 23.8414 16.1581 26.9559 19.9999 26.9559C21.893 26.9559 23.6083 26.1988 24.8625 24.9722C24.063 25.4056 23.1471 25.6517 22.1738 25.6517Z"
        fill="#D80027"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_112590">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default TunisiaSvg;
